'use strict';

import {throttle} from '../../components/custom-lodash';

var footerIcons = {
    init: function () {
        var lazyloadImages = Array.prototype.slice.call(document.querySelectorAll('.lazy'), 0);
        var socialIcons = Array.prototype.slice.call(
            document.querySelectorAll('.footer-section-social .icon-tile i:not(.loaded)'),
            0
        );
        var logoIcons = Array.prototype.slice.call(document.querySelectorAll('.footer-icon-logo:not(.loaded)'), 0);

        if (socialIcons.length > 0) {
            lazyloadImages = lazyloadImages.concat(socialIcons);
        }

        if (logoIcons.length > 0) {
            lazyloadImages = lazyloadImages.concat(logoIcons);
        }

        if ('IntersectionObserver' in window) {
            var imageObserver = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        var image = entry.target;
                        image.classList.remove('lazy');
                        image.classList.add('loaded');
                        imageObserver.unobserve(image);
                    }
                });
            });

            lazyloadImages.forEach(function (image) {
                imageObserver.observe(image);
            });
        } else {
            function lazyload() {
                var scrollTop = window.pageYOffset;
                lazyloadImages.forEach(function (img) {
                    if (img.offsetTop < window.innerHeight + scrollTop) {
                        img.src = img.dataset.src;
                        img.classList.remove('lazy');
                        img.classList.add('loaded');
                    }
                });
                if (lazyloadImages.length == 0) {
                    document.removeEventListener('scroll', lazyload);
                }
            }

            document.addEventListener('scroll', throttle(lazyload, 50));
        }
    }
};

module.exports = footerIcons;
